import React from 'react';

import './styles.scss';

const HorizontalRule = () => {
  return <hr className="horizontal-rule" />;
};

export default HorizontalRule;
